/** Área privada de El Corte Inglés: origen `ticketingStore` para que la cuenta sepa de dónde llega el usuario. */
export const MY_ACCOUNT_URL = 'https://cuenta.elcorteingles.es/?source=ticketingStore'
export const MY_PURCHASES_URL = 'https://cuenta.elcorteingles.es/consulta-tu-compra/?source=ticketingStore'

export const MY_ACCOUNT_LABEL = 'Mi cuenta'
export const MY_PURCHASES_LABEL = 'Mis compras'
export const SIGN_OUT_LABEL = 'Cerrar sesión'

/** Título del panel, igual que el de elcorteingles.es. */
export const ACCOUNT_DRAWER_TITLE = 'Accesos'

/** Saludo del título con sesión y nombre: «Hola, {nombre}» (como elcorteingles.es). */
export const ACCOUNT_DRAWER_GREETING = 'Hola'

/** CTA de login del panel sin sesión (mismo texto que elcorteingles.es). */
export const SIGN_IN_LABEL = 'Iniciar sesión o crear cuenta'

/** Nombre accesible del icono que abre el panel, sin sesión. */
export const ACCOUNT_TRIGGER_LABEL = 'Iniciar sesión'

/** Nombre accesible del icono que abre el panel, con sesión iniciada. */
export const ACCOUNT_TRIGGER_LOGGED_IN_LABEL = 'Mi cuenta (sesión iniciada)'

/** Tamaño de los iconos de cada fila (24×24, igual que la referencia). */
export const ROW_ICON_SIZE = 24

/** Tamaño del icono de flecha del CTA de login (20×20, igual que la referencia). */
export const CTA_ICON_SIZE = 20
